// extracted by mini-css-extract-plugin
export default {"dtg-layout-about__content":"dtg-layout-about__content_prbDd","dtg-layout-about__footer":"dtg-layout-about__footer_Mz03L"};